<template>
    <div>
        <div class="d-flex align-items-center filter-wrapper flex-wrap">
            <div class="form-group">
                <label>Дата начала периода</label>
                <date-component v-model="currFilters.dateFrom"/>
            </div>
            <div class="form-group">
                <label>Дата окончания периода</label>
                <date-component v-model="currFilters.dateTo"/>
            </div>
            <div class="form-group select2">
                <label>Район</label>
                <Select2 :options="districts" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.districtIds"/>
            </div>
            
          <div class="form-group  select2">
                <label>Возраст</label>
                <Select2 :options="fields" :settings="{multiple:true,language:'ru'}" placeholder="(Выберите поля)"
                         v-model="currFilters.fields"/>
            </div>

          <div class="form-group px-0 col-12">
            <div class="check-box-group pt-4">
              <Checkbox v-model="currFilters.includeInvalid"
                        :checked="currFilters.includeInvalid"
                        id="includeInvalid"
                        text="инвалидность"
              />
            </div>
          </div>
          <div class="form-group  px-0">
                <div class="card-footer pt-2 px-0  d-flex">
                    <button-component @click="apply" class="btn-xs">Сформировать</button-component>
                    <button-component kind="secondary" class="btn-xs" @click="reset">Сбросить</button-component>
                    <button class="btn-success btn-d btn-xs" @click="exportReport">
                        <i class="fa fa-download"></i>Экспорт</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import DateComponent from "../../../common/components/DateComponent";
  import ButtonComponent from "../../../common/ui/ButtonComponent";
  import Checkbox from "../../../common/ui/checkbox";
  import NsiApi from "../../admin/api/nsi";
  import Api from "../api/ras";
  import {useVuelidate} from '@vuelidate/core'
  import Constants from '../../../common/constants'
  import moment from 'moment'

  const dateLessValidator = (value) => value == null || value <= moment(new Date()).format("YYYY-MM-DD");

  export default {
    name: "ReportRasFilter",
    components: {ButtonComponent, DateComponent, Checkbox},
    props: {
      filters: Object
    },
    data() {
      return {
        districts: [],
        fields: [],
        currFilters: this.filters
      }
    },
    created() {
      this.loadDictionaries();
    },
    methods: {
      loadDictionaries() {
        NsiApi.getNsi('district')
          .then((response) => {
            this.districts = response.data;
          });
        Api.getReportFields()
          .then((response) => {
            this.fields = response.data.map((x) => ({id: x.name, text: x.title}));
            this.currFilters.fields = this.fields.map(item => item.id)
          });
      },
      apply() {

        this.v$.$touch();
            if (this.v$.$invalid) {
              Constants.alert.fire('Ошибка', 'Поле "Дата начала периода" не может быть больше текущей даты', 'error');
              return;
            }

        const filters = Object.assign({}, this.currFilters);
        if(filters.male == 1)
            filters.male = null;

        this.$emit('apply', filters);
      },
      reset() {
        this.currFilters = {
          dateFrom: null,
          dateTo: null,
          districtIds: [],          
          fields: ['year3', 'year7', 'year12', 'year17', 'year18', 'yearOld'],
          includeInvalid: true
        };
        const filters = Object.assign({}, this.currFilters);
        this.$emit('reset', filters);
      },
      exportReport() {
        const filters = Object.assign({}, this.currFilters);
        this.$emit('exportReport', filters);
      }
    },

    setup: () => ({v$: useVuelidate()}),
    validations() {
        return {
            currFilters: {
                dateFrom: {
                  dateLessValidator
                }
            }
        }
    }
  }
</script>

<style lang="scss" scoped>
    @import "src/assets/theme/default/colors";

    .form-group {
        label {
            font-weight: 400 !important;
            color: $gray-dark;
            font-size: 16px;
        }
    }
    .filter-wrapper{
        div:not(:last-child){
            margin-right: 16px;
        }
    }
    .card-footer {
        padding-top: 36px;
        gap: 16px;
        align-items: center;
        justify-content: space-between;
    }
    .btn-d{
      min-width: 120px;
        border: none;
        padding: 14px 24px;
        border-radius: 24px;
        i{
            padding-right: 12px;
        }
    }
</style>